<template>
    <div class="topbar-box" style="">
        <div class="topbar-logo flex-row-start" style="height:100%;min-width:200px;float:left;text-indent:20px;">
            <!-- <img class="topbar-logo-img" src="../assets/logo.png"/> -->
            时代科技OA系统
        </div>
        <div class="flex-row-end admin-box" hidden-md-and-down style="">
            <div class="Screen">
      <i class="el-icon-full-screen iconFont" @click="toggleFull"></i>
      </div>
            <div class="admin-msg">
                <p>{{adminName}}</p>
                <p>{{caps}}</p>
            </div>
            <div style="width:40px;height:auto;margin-right:10px;border-radius:50%;">
                <img class="topbar-photo" src="../assets/images/icon/profile.png"/>
            </div>
            <div class='topbar-dropdown'>
                <el-dropdown @command="handleTags">
                    <el-button size="mini" type="primary">
                        <i class="icon iconfont topbar-icon icon-gengduo"></i>
                    </el-button>
                    <el-dropdown-menu size="small" slot="dropdown">
                        <el-dropdown-item command="a">修改密码</el-dropdown-item>
                        <el-dropdown-item command="b">安全退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dialog :title="editFormVisibleTitle" :visible.sync="addFormVisible" :close-on-click-modal='false' width='500px'>
          <div class='dialogBody'>
              <el-form :model="editForm" label-width="150px!important"  :rules="rules" ref="editForm" style='display:block' label-position='right' class="xiugai">
                  <el-form-item label="请输入原始密码:" prop="oldPassword">
                      <el-input v-model.trim="editForm.oldPassword" class='dialog-width' placeholder="请输入原始密码" show-password></el-input>
                  </el-form-item>
                  <el-form-item label="请输入新密码:" prop="newPassword">
                      <el-input v-model.trim="editForm.newPassword" class='dialog-width' placeholder="请输入新密码" show-password></el-input>
                  </el-form-item>
                  <el-form-item label="请重复输入新密码:" prop="newPasswordAgain">
                      <el-input v-model.trim="editForm.newPasswordAgain" class='dialog-width' placeholder="请重复输入新密码" show-password></el-input>
                  </el-form-item>
              </el-form>
          </div> 
          <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="preserve">保存</el-button>
          <el-button @click.native="addFormVisible = false">关闭</el-button>
          </div>
        </el-dialog>
    </div>
</template>


<script>
    import Auth from '../services/auth';
    import screenfull from 'screenfull';
    import md5 from "js-md5"

    export default {
        name: 'topbar',
        data() {
            return {
                activeIndex: '4',
                adminName: '',
                flag: true,
                caps:'',
                editFormVisibleTitle:"修改密码",
                addFormVisible:false,
                rules: {
          oldPassword: [
            { required: true, message: '请输入原始密码', trigger: 'blur' },
            { min: 6, max: 15, message: "长度在 6 到 15 个字符", trigger: "blur" }
          ],
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 15, message: "长度在 6 到 15 个字符", trigger: "blur" }
          ],
          newPasswordAgain: [
            { required: true, message: '请重复输入新密码', trigger: 'blur' },
            { min: 6, max: 15, message: "长度在 6 到 15 个字符", trigger: "blur" }
          ],
            },
          editForm:{
        oldPassword:"",
        newPassword:"",
        newPasswordAgain:"",
      },
        }
        },
        created: function () {
            // var user = Auth.getUser();
            // // console.log(user)
            // if(user==false){
            //     // next({path:'/login'}) 
            //      this.$router.push({name:'login'});
            //     return false
            // }
            // this.adminName = user.username;
            this.caps=JSON.parse(JSON.parse(localStorage.getItem('mmm')).data).userName;
            // console.log(this.caps);       
        },
        methods: {
            handleSelect(key, keyPath) {
                // console.log(key, keyPath);
            },
            preserve(){
                this.$refs['editForm'].validate((valid) => {
          if (valid) {
             if(this.editForm.oldPassword==this.editForm.newPassword){
              this.$message({
                        message: '新密码和旧密码不能一样',
                        type: 'warning'
                    });
                    return false
            }else if(this.editForm.newPassword!=this.editForm.newPasswordAgain){
              this.$message({
                        message: '两次密码输入不一致',
                        type: 'warning'
                    });
                    return false
            }else{
            var key = '32ADFED602DA49788188858BE1C99068';
            var formData={
            oldPassword:md5(encodeURIComponent((this.editForm.oldPassword)+key)),
            userPassword:md5(encodeURIComponent((this.editForm.newPassword)+key)),
            }
            this.postFn(this.$apis.updatePassword, formData,(res)=>{
                   if(res.body.retCode=="0000"){
                this.$message({message:"修改成功",type: 'success'});
    }else{
    this.$message({message:res.body.retMsg,type: 'error'});
    }
                   
                })
                this.addFormVisible=false;
            }
          } else {
            this.$message.error("请完善修改信息");
            return false;
          }
        });

            },
            //全屏切换
    toggleFull(){
      if (screenfull.enabled) {
        this.$message({
          type: 'warning',
          message: 'you browser can not work'
        })
        return false
      }
      screenfull.toggle()
    },
            exitBtn() {
                console.log(11)
                Auth.logout();
                // 退出后，清空activeItem菜单缓存
                sessionStorage.clear();
                localStorage.clear();
                return this.$router.push({name: 'login'});
            },
            handleTags(command){
                if(command=="a"){
                 this.addFormVisible=true;
                 if (this.$refs["editForm"] !== undefined) {
                    this.$refs["editForm"].resetFields();
                }
                }else if(command=="b"){
                 this.exitBtn();
                }
            }
        }
    }
</script>
<style lang="scss">

    html, body, .topbar-box {
        width: 100%;
        height: 100%;
       
    }
    .Screen  .el-icon-full-screen:before {
  height: 40px!important;
  width: 40px!important;
  margin-right:10px;
  cursor: pointer;
}
.Screen:hover{
  opacity:0.8;
}
    .topbar-dropdown .el-button--primary{
        background: none;
        border:none;
        padding:0 0;
    }
    .topbar-box{
        box-sizing: border-box;
        background: $top-bg;
    }
    * {
        margin: 0;
        padding: 0;
    }

    @media (min-width: 768px) and (max-width: 1920px) {
        .admin-msg {
            margin-right: 0.606rem;
            line-height: 1.4;
            color:#000;
        }

        .el-menu-demo {
            height: 60px;
        }

        .topbar-box .el-menu-item {
            height: 100% !important;
            font-size: 14px;
        }

        .admin-msg p:first-child {
            font-size: 15px;
            color: #444;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color:#000;
        }

        .admin-msg p:nth-child(2) {
            font-size: 12px;
            color: #ffe036;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color:#000;
        }
    }

    @media (min-width: 1920px) {
        .admin-msg {
            margin-right: 0.606rem;
            line-height: 1.5;
        }

        .el-menu-demo {
            height: 80px;
        }

        .topbar-box .el-menu-item {
            height: 100% !important;
            font-size: 16px;
        }

        .admin-msg p:first-child {
            font-size: 18px;
            color: #444;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color:#000;
        }

        .admin-msg p:nth-child(2) {
            font-size: 14px;
            color: #ffe036;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color:#000;
        }

    }

    .topbar-logo {
        background: $top-bg;
    }

    .topbar-logo-img {
        height:50%;
        margin: 0 auto;
    }

    .admin-box {
        height: 100%;
        float: right;
    }

    .admin-box:after {
        clear: both;
    }

    .topbar-photo {
        display: block;
        max-width: 100%;
        background: #fff;
        border-radius: 50%;
    }

    .topbar-icon {
        font-size: 1.4rem !important;
        color: #fff;
        margin-right:10px;
    }

    .topbar-box .el-menu-demo {
        width: 70%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
    }

    .topbar-box .el-menu.el-menu--horizontal {
        border: none;
    }

    li {
        list-style: none;
    }

    .dropdown-menu {
        position: absolute;
        top: 50px;
        right: -30px;
        padding: 10px 20px;
        font-size: 14px;
        white-space: nowrap;
        line-height: 30px;
        border-radius: 6px;
        -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        border: 1px solid #ddd;
        border: 1px solid rgba(0, 0, 0, 0.1);
        background: #fff;
        z-index: 100;
    }

    .fadeInRight {
        -webkit-animation-name: fadeInRight;
        -moz-animation-name: fadeInRight;
        -o-animation-name: fadeInRight;
        animation-name: fadeInRight;
    }

    .animated {
        -webkit-animation-fill-mode: both;
        -moz-animation-fill-mode: both;
        -ms-animation-fill-mode: both;
        -o-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-duration: 0.5s;
        -moz-animation-duration: 0.5s;
        -ms-animation-duration: 0.5s;
        -o-animation-duration: 0.5s;
        animation-duration: 0.5s;
    }

    .arrow {
        border-width: 8px;
        z-index: 10;
    }

    .arrow, .arrow:after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
    }

    .arrow.top {
        left: 50%;
        margin-left: -8px;
        border-top-width: 0;
        border-bottom-color: #eee;
        border-bottom-color: rgba(255, 255, 255, 1);
        top: -8px;
    }
    .xiugai .el-form-item {
        margin-bottom:20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/topbar.vue